module.exports = __webpack_public_path__ + "img/IMG_2729_L_WoodMatted.9a0532f2.jpg";